export enum Language {
    NonEnglish = 1,
    English = 2,
    Spanish = 3,
    French = 4,
    German = 5,
    Dutch = 6,
    Danish = 7,
    Swedish = 8,
    Portuguese = 9,
    Italian = 10,
    Romanian = 11,
    Turkish = 12,
}
